<template>
    <!-- 收益明细 [[ -->
    <div class="profit-tab-con reward-detail">
        <div class="profit-chart-top">
            <p class="profit-time-name f-inlineblock-top">任务时间</p>
            <div class="profit-time-con f-inlineblock-middle">
                <el-date-picker v-model="dateVal" @change="getList" type="daterange" :picker-options="pickerOptions" range-separator="至" :start-placeholder="defaultsDate" :end-placeholder="defaulteDate" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
        </div>

        <div class="profit-list">
            <el-table v-loading="loading" :data="tableData" stripe class="data-table" style="width: 100%">
                <el-table-column prop="date" label="任务时间" align="center">
                </el-table-column>
                <el-table-column prop="visitNum" label="页面曝光" align="right">
                    <template slot="header" slot-scope="scope">
                        页面曝光(去重)
                        <el-tooltip v-show="showTip" effect="dark" content="4月1日之前的数据未做记录，如有疑问，请咨询小助手~" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <span class="handle-pop" @click="getPopData('visit',scope.row)">
                            {{scope.row.visitNum | filterNum}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="downloadNum" label="点击下载" align="right">
                    <template slot="header" slot-scope="scope">
                        点击下载(去重)
                        <el-tooltip v-show="showTip" effect="dark" content="4月1日之前的数据未做记录，如有疑问，请咨询小助手~" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <span class="handle-pop" @click="getPopData('download',scope.row)">
                            {{scope.row.downloadNum | filterNum}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="registerNum" label="注册用户" align="right">
                    <template slot="header" slot-scope="scope">
                        注册用户(去重)
                        <el-tooltip v-show="showTip" effect="dark" content="4月1日之前的数据未做记录，如有疑问，请咨询小助手~" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.registerNum | filterNum }}
                    </template>
                </el-table-column>
                <el-table-column prop="profit" label="收益" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.profit}}
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-pagination v-show="total" style="text-align: center;" @current-change="getRewardContent()" :current-page.sync="params.page" :page-size="params.pageSize" layout="prev, pager, next, jumper" :total="total">
            </el-pagination> -->
            <el-dialog title="详情" :visible.sync="dialogVisible" width="500px">
                 <el-table :data="popData" height="450">
                    <el-table-column property="date" label="用户">
                        <template slot-scope="scope">
                            <img width="36" height="36" style="border-radius: 50%;margin-right: 5px;vertical-align: middle;" :src="scope.row.avatar || defaultAvatar" alt="">
                            <span>{{scope.row.userName}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column property="req_time" label="时间"></el-table-column> -->
                </el-table>
                <el-pagination
                    @current-change="getPopData(false)"
                    :current-page.sync="popParams.pageIndex"
                    :page-size="popParams.pageSize"
                    style="text-align: center;margin-top: 20px;"
                    layout="prev, pager, next"
                    :total="popTotal">
                </el-pagination>
            </el-dialog>
        </div>
    </div>
    <!-- 收益明细 ]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/profit/profit.scss';
.profit-chart-top .profit-time-name {
    line-height: 35px;
}
.profit-time-name {
    margin-right: 30px;
}
.profit-chart-top {
    margin-bottom: 30px;
}
.data-table {
    border: 1px solid #ebeef5;
    margin-bottom: 30px;
}
.handle-pop{
    cursor: pointer;
    color: #409eff;
}
</style>
<script>
import { DownloadDataDaily, DownloadDataDailyDetail } from "Services/getData.js";
export default {
    data() {
        return {
            defaultAvatar: require('../../../assets/img/pages/v4/admin.png'),
            popParams: {
                dataTime: '',      //	开始时间	string	否	null	开始时间
                type: '',       //	统计类型	string	否	null	统计类型：visit(曝光)、download(下载)
                pageIndex: 1,  //	当前页	int	否	null	当前页
                pageSize: 10,   //
            },
            popData: [],
            popTotal: 0,
            dialogVisible: false,
            dateVal: [],
            defaultsDate: "",
            defaulteDate: "",
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.choiceDate = minDate.getTime();
                    if (maxDate) {
                        this.choiceDate = "";
                    }
                },
                disabledDate: time => {
                    if (this.choiceDate) {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.choiceDate - one;
                        const maxTime = this.choiceDate + one;
                        return (
                            time.getTime() < minTime ||
                            time.getTime() > maxTime ||
                            time.getTime() > Date.now()
                        );
                    } else {
                        return time.getTime() > Date.now();
                    }
                }
            },
            choiceDate: "",
            tableData: [],
            total: 1,
            params: {
                page: 1,
                pageSize: 10
            },
            loading: false,
            showTip: false,
        };
    },
    mounted() {
        let startDate = Date.now() - 8.64e7 * 6;
        let endDate = Date.now();

        this.dateVal = [
            this.$common.formatDate(startDate, "-"),
            this.$common.formatDate(endDate, "-")
        ];
        this.defaultsDate = this.$common.formatDate(startDate, "-");
        this.defaulteDate = this.$common.formatDate(endDate, "-");
        this.getList();
    },
    methods: {
        async getPopData(type,item){
            if(type === false){

            }else{
                this.dialogVisible = true;
                this.popParams.type = type;
                this.popParams.dataTime = item.date;
                this.popParams.pageIndex = 1;
            }
            let res = await DownloadDataDailyDetail(this.popParams)
            if(res.data.code === 0 && res.status === 200){
                this.popTotal = res.data.data.total;
                this.popData = res.data.data.data;
            }
        },
        async getList() {
            this.loading = true;
            let res = await DownloadDataDaily({
                start: this.dateVal[0],
                end: this.dateVal[1]
            });
            this.loading = false;
            if (res.status === 200 && res.data.code === 0) {
                this.tableData = res.data.data;
            }
        }
    },
    watch: {
        dateVal(n,o){
            console.log(n)
            let time = new Date('2020-04-02').getTime();
            let chooseTime = new Date(n[0]).getTime();
            if(chooseTime < time){
                this.showTip = true;
            }else{
                this.showTip = false;
            }
        }
    },
};
</script>
